var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 17.69 23.65",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.08 0h7.91l6.7 6.99v13.58c0 1.7-1.38 3.08-3.08 3.08h-11.53c-1.7 0-3.08-1.38-3.08-3.08v-17.49c0-1.7 1.38-3.08 3.08-3.08z",
    fill: "#00733B"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.98 0 10.98 6.93 17.69 6.93",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.21 17.35h3.14v1.19h-3.14v-1.19zm4.12-6.08h3.15v1.18h-3.15v-1.18zm-4.12 0h3.14v1.18h-3.14v-1.18zm4.12 2h3.15v1.19h-3.15v-1.19zm-4.12 0h3.14v1.19h-3.14v-1.19zm4.12 2.08h3.15v1.19h-3.15v-1.19zm-4.12 0h3.14v1.19h-3.14v-1.19zm4.12 2h3.15v1.19h-3.15v-1.19z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.277766d3ab2acbefcf88d0797460237d.svg";
export { ForwardRef as ReactComponent };